export default __webpack_public_path__ + "static/media/dhs-seal.0c55b966c486204d88611b1567c53617.svg";